import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerStyle = {
    backgroundColor: '#f1f1f1',
    padding: '15px',
    textAlign: 'center',
    width: '100%', // Ensure full width
    fontSize: '14px',
    color: '#333',
    marginTop: 'auto', // Push the footer as far down as possible
  };

  const paragraphStyle = {
    margin: 0,
  };

  return (
    <footer style={footerStyle}>
      <p style={paragraphStyle}>&copy; {currentYear} Jared Volle. All rights reserved.</p>
    </footer>
  );
};

{/* 
footer {
  background-color: #f1f1f1;
  padding: 15px;
  text-align: center;
  width: 100%;
  font-size: 14px;
  color: #333;
  margin-top: auto;
}

footer p {
  margin: 0;
}

*/}

export default Footer;
